import PropType from 'prop-types';
import React from 'react';

export const Button = props => {
  const { onClick, children, buttonType, disabled, additionalClassName, additionalStyle, isLoading, progress } = props;
  const additionalProps = { ...props };
  delete additionalProps.buttonType;
  delete additionalProps.additionalClassName;
  delete additionalProps.additionalStyle;
  delete additionalProps.isLoading;

  if (progress && progress > 0) {
    if (buttonType === 'ghost' || buttonType === 'link') {
      throw Error('Progress prop can only be used with these modes: primary, secondary, tertiary');
    }
  }

  const buttonClasses = [];

  buttonClasses.push(buttonType || 'primary');

  if (additionalClassName && additionalClassName?.length > 0) {
    buttonClasses.push(...additionalClassName);
  }

  /* It will render loading button */
  if (isLoading) {
    buttonClasses.push('is-loading');
  }

  const spanClasses = ['button-container'];

  /* It will render link button */
  if (buttonType === 'link') {
    spanClasses.push('link');
  }

  /* It will render disable button */
  if (disabled === true) {
    spanClasses.push('disabled');
  }

  return (
    <span className={spanClasses.join(' ')}>
      <button
        data-testid="button"
        type="button"
        onClick={onClick}
        style={{ ...(additionalStyle || undefined) }}
        className={buttonClasses.join(' ')}
        {...additionalProps}>
        {progress && progress > 0 ? (
          <div
            style={{
              backgroundColor: buttonType === 'tertiary' ? '#b3dbdc' : '#ffffff',
              width: `${progress * 100}%`,
              opacity: 0.2,
              transition: 'width 1s -0.1s ease-in-out',
              height: 'inherit',
              position: 'absolute',
              left: 0,
              top: 0,
            }}
          />
        ) : null}
        {children}
      </button>
    </span>
  );
};

Button.propTypes = {
  onClick: PropType.func,
  children: PropType.any,
  buttonType: PropType.oneOf(['primary', 'link', 'secondary', 'tertiary', 'ghost']),
  disabled: PropType.bool,
  additionalClassName: PropType.arrayOf(PropType.string),
  additionalStyle: PropType.object,
  isLoading: PropType.bool,
  progress: PropType.number,
};
